export default "__VITE_ASSET__BqN9bElV__"